/* eslint-disable @typescript-eslint/no-redeclare */
import { AttentionDisplayGroup } from '@crew/enums/app'
import AlternateEmail from '~icons/material-symbols/alternate-email'
import BookmarkOutline from '~icons/material-symbols/bookmark-outline'
import BaselineEvent from '~icons/ic/baseline-event'
import ChatOutline from '~icons/material-symbols/chat-outline'
import InformationBox from '~icons/mdi/information-box'
import EventAvailable from '~icons/material-symbols/event-available'
import BaselineQueryBuilder from '~icons/ic/baseline-query-builder'
import OutlineInsertDriveFile from '~icons/ic/outline-insert-drive-file'
import GroupOutline from '~icons/material-symbols/group-outline'
import Subject from '~icons/material-symbols/subject'
import OutlinePhotoSizeSelectActual from '~icons/ic/outline-photo-size-select-actual'
import Groups from '~icons/material-symbols/groups'
import EmoticonHappyOutline from '~icons/mdi/emoticon-happy-outline'
import BaselineReply from '~icons/ic/baseline-reply'
import AccountClock from '~icons/mdi/account-clock'
import AccountTreeOutline from '~icons/material-symbols/account-tree-outline'
import ArchiveLine from '~icons/ri/archive-line'
import BaseOutlineVideocam from '~icons/ic/outline-videocam'
import North from '~icons/material-symbols/north'
import South from '~icons/material-symbols/south'
import ViewListOutLineSharp from '~icons/material-symbols/view-list-outline-sharp'
import ViewColumnOutlineSharp from '~icons/material-symbols/view-column-outline-sharp'
import BaselineToday from '~icons/ic/baseline-today'
import ViewHeadline from '~icons/material-symbols/view-headline'
import GanttChart24Regular from '~icons/fluent/gantt-chart-24-regular'
import ShowChart from '~icons/material-symbols/show-chart'
import GridViewOutline from '~icons/material-symbols/grid-view-outline'
import { CrewAiAssistantIcon } from 'components/elements/crewAiAssistantIcon/crewAiAssistantIcon'

// 優先度アイコン
import ChevronDoubleUp from '~icons/mdi/chevron-double-up'
import ChevronUp from '~icons/mdi/chevron-up'
import Minus from '~icons/mdi/minus'
import ChevronDown from '~icons/mdi/chevron-down'
import ChevronDoubleDown from '~icons/mdi/chevron-double-down'
import { ToolTipTypes } from 'components/devextreme/crewGuideToolTip/crewGuideToolTip'

/**
 *  イベントタイプ
 */
export const NotifyEventType = {
  Inserted: 'inserted',
  Updated: 'updated',
  Deleted: 'deleted',
} as const

export type NotifyEventType =
  (typeof NotifyEventType)[keyof typeof NotifyEventType]

// フィルタ条件（活動）
export const EventFilters = {
  AllEvents: 'allEvents',
  MyEvent: 'myEvent',
} as const

export type EventFilters = (typeof EventFilters)[keyof typeof EventFilters]

// type filter (event)
export const EventKindFilters = {
  AllEventKinds: 'allTypes',
} as const

export type EventKindFilters =
  (typeof EventKindFilters)[keyof typeof EventKindFilters]

// type filter (task)
export const TaskKindFilters = {
  AllTaskKinds: 'allTypes',
} as const

export type TaskKindFilters =
  (typeof TaskKindFilters)[keyof typeof TaskKindFilters]

// フィルタ条件（タスク）
export const TaskFilters = {
  UncompletedTasks: 'uncompletedTasks',
  MyTasks: 'myTasks',
  AllTasks: 'allTasks',
} as const

export type TaskFilters = (typeof TaskFilters)[keyof typeof TaskFilters]

export const ProjectFilters = {
  ParticipatingProjects: 'participatingProjects',
  MyProjects: 'myProjects',
  ActiveProjects: 'activeProjects',
  ArchivedProjects: 'archivedProjects',
} as const

export type ProjectFilters =
  (typeof ProjectFilters)[keyof typeof ProjectFilters]

// project scope
export const ProjectScope = {
  Public: {
    key: 'public',
    name: 'パブリック',
  },
  Private: {
    key: 'private',
    name: 'プライベート',
  },
} as const

export type ProjectScope = (typeof ProjectScope)[keyof typeof ProjectScope]

// フィルタ条件（タスク種別）
export const TimeFlag = {
  Newer: 'newer',
  Default: 'default',
  Older: 'older',
  Independent: 'independent',
} as const

export type TimeFlag = (typeof TimeFlag)[keyof typeof TimeFlag]

/**
 * 時間軸上での向き
 */
export const TimelineDirection = {
  /** より新しい方 */
  Newer: 'newer',
  /** より古い方 */
  Older: 'older',
  /** Both newer and orlder */
  BothNewerAndOlder: 'bothNewerAndOlder',
} as const
export type TimelineDirection =
  (typeof TimelineDirection)[keyof typeof TimelineDirection]

/**
 * Project progress list items
 */
export const ProjectProgressItems = {
  Completed: {
    text: 'completed',
    displayColor: 'bg-crew-blue-3-light dark:bg-crew-blue-3-dark',
  },
  Incomplete: {
    text: 'incomplete',
    displayColor: 'bg-crew-blue-2-light dark:bg-crew-blue-2-dark',
  },
  Overdue: {
    text: 'overdue',
    displayColor: 'bg-crew-red-3-light dark:bg-crew-red-3-dark',
  },
} as const
export type ProjectProgressItems =
  (typeof ProjectProgressItems)[keyof typeof ProjectProgressItems]

export const ProjectDetailTabs = {
  Chat: {
    id: 'project-detail-tab-chat',
    text: 'label.chat',
    value: 'chat',
    icon: ChatOutline,
    isDefault: true,
  },
  Meeting: {
    id: 'project-detail-tab-meeting',
    text: 'label.meeting',
    value: 'meeting',
    icon: BaseOutlineVideocam,
    isDefault: false,
  },
  Task: {
    id: 'project-detail-tab-task',
    text: 'label.task',
    value: 'task',
    icon: EventAvailable,
    isDefault: false,
  },
  File: {
    id: 'project-detail-tab-file',
    text: 'label.file',
    value: 'file',
    icon: OutlineInsertDriveFile,
    isDefault: false,
  },
  Member: {
    id: 'project-detail-tab-member',
    text: 'label.member',
    value: 'member',
    icon: GroupOutline,
    isDefault: false,
  },
} as const
export type ProjectDetailTabs =
  (typeof ProjectDetailTabs)[keyof typeof ProjectDetailTabs]

export const DirectMessageTabs = {
  Chat: {
    text: 'label.chat',
    value: 'chat',
    icon: ChatOutline,
    isDefault: true,
  },
  File: {
    text: 'label.file',
    value: 'file',
    icon: OutlineInsertDriveFile,
    isDefault: false,
  },
} as const
export type DirectMessageTabs =
  (typeof DirectMessageTabs)[keyof typeof DirectMessageTabs]

export const AppTheme = {
  Light: 'light',
  Dark: 'dark',
} as const
export type AppTheme = (typeof AppTheme)[keyof typeof AppTheme]

export const AppLanguage = {
  En: 'en',
  Ja: 'ja',
} as const
export type AppLanguage = (typeof AppLanguage)[keyof typeof AppLanguage]

export const EventDetailTabs = {
  Detail: {
    id: 'event-detail-tab-detail',
    text: 'label.detail',
    value: 'detail',
    icon: Subject,
    isDefault: true,
  },
  MeetingMinutes: {
    id: 'event-detail-tab-meeting-minutes',
    text: 'label.meetingMinutes',
    value: 'meetingMinutes',
    icon: ArchiveLine,
    isDefault: true,
  },
  Attendee: {
    id: 'event-detail-tab-attendee',
    text: 'label.attendee',
    value: 'attendee',
    icon: GroupOutline,
    isDefault: false,
  },
  Task: {
    id: 'event-detail-tab-task',
    text: 'label.task',
    value: 'task',
    icon: EventAvailable,
    isDefault: false,
  },
  File: {
    id: 'event-detail-tab-file',
    text: 'label.file',
    value: 'file',
    icon: OutlineInsertDriveFile,
    isDefault: false,
  },
} as const
export type EventDetailTabs =
  (typeof EventDetailTabs)[keyof typeof EventDetailTabs]

/**
 * Project setting tab list item
 */
export const ProjectSettingTabs = {
  AdvancedSetting: {
    text: 'label.advancedSetting',
    value: 'advancedSetting',
    isDefault: true,
  },
  EventKind: {
    text: 'label.meetingKind',
    value: 'eventKind',
    isDefault: false,
  },
  //   TODO: イベント分類タブは下記タスクで非表示としたため、現状未使用。
  // https://break-tmc.atlassian.net/browse/CREW-15044
  //   EventCategory: {
  //     text: 'label.eventCategory',
  //     value: 'eventCategory',
  //     isDefault: false,
  //   },
  TaskKind: {
    text: 'label.taskKind',
    value: 'taskKind',
    isDefault: false,
  },
  TaskCategory: {
    text: 'label.taskCategory',
    value: 'taskCategory',
    isDefault: false,
  },
  TaskStatus: {
    text: 'label.taskState',
    value: 'taskStatus',
    isDefault: false,
  },
} as const
export type ProjectSettingTabs =
  (typeof ProjectSettingTabs)[keyof typeof ProjectSettingTabs]

// 【テナント設定】タブ一覧
export const TenantSettingTabs = {
  Organization: {
    id: 'tenant-setting-tab-organization',
    text: 'label.organization',
    value: 'organization',
    isDefault: true,
  },
  Authority: {
    id: 'tenant-setting-tab-authority',
    text: 'label.authority',
    value: 'authority',
    isDefault: false,
  },
  User: {
    id: 'tenant-setting-tab-user',
    text: 'label.user',
    value: 'user',
    isDefault: false,
  },
  EventKind: {
    id: 'tenant-setting-tab-event-kind',
    text: 'label.eventKind',
    value: 'eventKind',
    isDefault: false,
  },
  PresenceStatus: {
    id: 'tenant-setting-tab-presence-status',
    text: 'label.presenceStatus',
    value: 'presenceStatus',
    isDefault: false,
  },
  ProjectGroup: {
    id: 'tenant-setting-tab-project-group',
    text: 'label.projectGroup',
    value: 'projectGroup',
    isDefault: false,
  },
} as const
export type TenantSettingTabs =
  (typeof TenantSettingTabs)[keyof typeof TenantSettingTabs]

// Personal setting tab list
export const PersonalSettingTabs = {
  Profile: {
    id: 'personal-setting-tab-profile',
    text: 'label.personalProfile',
    value: 'profile',
    isDefault: true,
  },
  Display: {
    id: 'personal-setting-tab-display',
    text: 'label.personalDisplay',
    value: 'display',
    isDefault: false,
  },
  Notification: {
    id: 'personal-setting-tab-notification',
    text: 'label.notification',
    value: 'notification',
    isDefault: false,
  },
  Security: {
    id: 'personal-setting-tab-security',
    text: 'label.security',
    value: 'security',
    isDefault: false,
  },
} as const
export type PersonalSettingTabs =
  (typeof PersonalSettingTabs)[keyof typeof PersonalSettingTabs]

export const TaskListOrderItems = {
  Id: {
    value: 'id',
    text: 'label.id',
  },
  Type: {
    value: 'taskKindName',
    text: 'label.classification',
  },
  Title: {
    value: 'subject',
    text: 'label.subject',
  },
  Priority: {
    value: 'taskPriority',
    text: 'label.priority',
  },
  Status: {
    value: 'taskStateDisplayOrder',
    text: 'label.status',
  },
  AssignedUser: {
    value: 'assignToUserName',
    text: 'label.assignedUser',
  },
  DueDate: {
    value: 'dueDate',
    text: 'label.dueDate',
  },
} as const

export type TaskListOrderItems =
  (typeof TaskListOrderItems)[keyof typeof TaskListOrderItems]

export const FileListOrderItems = {
  Name: {
    value: 'name',
    text: 'label.fileName',
  },
  Revision: {
    value: 'revision',
    text: 'label.version',
  },
  Size: {
    value: 'size',
    text: 'label.size',
  },
  UpdatedBy: {
    value: 'updatedBy',
    text: 'label.updatedBy',
  },
  LastUpdatedAttachmentAt: {
    value: 'lastUpdatedAttachmentAt',
    text: 'label.updateDatetime',
  },
} as const

export type FileListOrderItems =
  (typeof FileListOrderItems)[keyof typeof FileListOrderItems]

// プロジェクト一覧 詳細検索の並べ替え項目リスト
export const ProjectListOrderItems = {
  ProjectName: {
    value: 'subject',
    text: 'label.projectName',
  },
  Description: {
    value: 'description',
    text: 'label.description',
  },
  OwnerUser: {
    value: 'ownerUserName',
    text: 'label.owner',
  },
} as const

export type ProjectListOrderItems =
  (typeof ProjectListOrderItems)[keyof typeof ProjectListOrderItems]

// filter scope
export const FilterScope = {
  Public: {
    key: 'public',
    name: 'label.public',
  },
  Private: {
    key: 'private',
    name: 'label.private',
  },
} as const

export type FilterScope = (typeof FilterScope)[keyof typeof FilterScope]

// タスク優先度
export const TaskPriorities = {
  Highest: {
    value: 5,
    text: 'label.highest',
    textColorClass: 'crew-badge-red',
    iconColorClass: 'crew-badge-icon-red',
    iconClass: ChevronDoubleUp,
  },
  High: {
    value: 4,
    text: 'label.high',
    textColorClass: 'crew-badge-red',
    iconColorClass: 'crew-badge-icon-red',
    iconClass: ChevronUp,
  },
  Normal: {
    value: 3,
    text: 'label.normal',
    textColorClass: 'crew-badge-green',
    iconColorClass: 'crew-badge-icon-green',
    iconClass: Minus,
  },
  Low: {
    value: 2,
    text: 'label.low',
    textColorClass: 'crew-badge-blue',
    iconColorClass: 'crew-badge-icon-blue',
    iconClass: ChevronDown,
  },
  Lowest: {
    value: 1,
    text: 'label.lowest',
    textColorClass: 'crew-badge-blue',
    iconColorClass: 'crew-badge-icon-blue',
    iconClass: ChevronDoubleDown,
  },
} as const
export type TaskPriorities =
  (typeof TaskPriorities)[keyof typeof TaskPriorities]

// ホームメニュー
export const HomeMenuItems = {
  // TODO: ダッシュボードが実装される際にコメントアウトを解除
  // ダッシュボード
  // Dashboard: {
  //   id: 'home-menu-dashboard',
  //   path: 'dashboard',
  //   label: 'label.dashboard',
  //   icon: 'dx-icon-mediumiconslayout',
  //   showRightPanel: false,
  // },
  // メンションと返信
  MentionAndReply: {
    id: 'home-menu-mention-and-reply',
    path: 'mentionAndReply',
    label: 'label.mentionAndReply',
    icon: AlternateEmail,
    showRightPanel: true,
    value: 'mentionAndReply',
  },
  // 新着
  NewArrival: {
    id: 'home-menu-new-arrival',
    path: 'newArrival',
    label: 'label.newArrival',
    icon: BaselineQueryBuilder,
    showRightPanel: true,
    value: 'newArrival',
  },
  // お知らせ
  Announcement: {
    id: 'home-menu-announcement',
    path: 'announcement',
    label: 'label.announcement',
    icon: InformationBox,
    showRightPanel: true,
    value: 'announcement',
  },
  // ブックマーク
  Bookmark: {
    id: 'home-menu-bookmark',
    path: 'bookmark',
    label: 'label.bookmark',
    icon: BookmarkOutline,
    showRightPanel: true,
    value: 'bookmark',
  },
  // AIアシスタント
  AiAssistant: {
    id: 'home-menu-ai-assistant',
    path: 'ai-assistant',
    label: 'label.aiAssistant',
    icon: CrewAiAssistantIcon,
    showRightPanel: true,
    value: 'aiAssistant',
  },
  // スケジュール
  Schedule: {
    id: 'home-menu-schedule',
    path: 'schedule',
    label: 'label.schedule',
    icon: BaselineEvent,
    showRightPanel: false,
    value: 'schedule',
  },
  // マイタスク
  MyTask: {
    id: 'home-menu-my-task',
    path: 'myTask',
    label: 'label.myTask',
    icon: EventAvailable,
    showRightPanel: false,
    value: 'myTask',
  },
  // 作業時間
  WorkingTime: {
    id: 'home-menu-working-time',
    path: 'workingTime',
    label: 'label.workingTime',
    icon: AccountClock,
    showRightPanel: false,
    value: 'workingTime',
  },
} as const
export type HomeMenuItems = (typeof HomeMenuItems)[keyof typeof HomeMenuItems]

// メンションと返信画面のタブ
export const AttentionTabType = {
  // 全て
  All: {
    text: 'label.all',
    value: AttentionDisplayGroup.All,
    icon: undefined,
    isDefault: true,
  },
  // メンション
  Mention: {
    text: 'label.mention',
    value: AttentionDisplayGroup.Mention,
    icon: AlternateEmail,
    isDefault: false,
  },
  // 返信
  Reply: {
    text: 'label.reply',
    value: AttentionDisplayGroup.Reply,
    icon: BaselineReply,
    isDefault: false,
  },
  // リアクション
  Reaction: {
    text: 'label.reaction',
    value: AttentionDisplayGroup.Reaction,
    icon: EmoticonHappyOutline,
    isDefault: false,
  },
} as const
export type AttentionTabType =
  (typeof AttentionTabType)[keyof typeof AttentionTabType]

export type ContextMenuItem = {
  action: string
  label: string
}

export const isContextMenuItem = (item: any): item is ContextMenuItem => {
  return (
    Boolean(item) &&
    (item as ContextMenuItem).action !== undefined &&
    (item as ContextMenuItem).label !== undefined
  )
}

// コンテキストメニューの編集 or 削除
export const ContextMenuItems = {
  ReadStatus: {
    action: 'readStatus',
    label: 'label.readStatus',
  },
  ReactionList: {
    action: 'reactionList',
    label: 'label.reactionList',
  },
  Edit: {
    action: 'edit',
    label: 'action.edit',
  },
  Delete: {
    action: 'delete',
    label: 'action.delete',
  },
  CopyLink: {
    action: 'copyLink',
    label: 'action.copyLink',
  },
} as const satisfies { [key: string]: ContextMenuItem }

export type ContextMenuItems =
  (typeof ContextMenuItems)[keyof typeof ContextMenuItems]

// お知らせページ内のアイテムに表示されるコンテキストメニュー
export const AnnouncementContextMenuItems = {
  // すべて既読にする
  AllRead: {
    action: 'markAllAsRead',
    label: 'label.markAllAsRead',
  },
  // 既読にする
  MarkAsRead: {
    action: 'markAsRead',
    label: 'label.markAsRead',
  },
  // 未読にする
  MarkAsUnread: {
    action: 'markAsUnread',
    label: 'label.markAsUnread',
  },
}

export type AnnouncementContextMenuItems =
  (typeof AnnouncementContextMenuItems)[keyof typeof AnnouncementContextMenuItems]

// タスク詳細ページのタブ
export const TaskDetailListTabs = {
  // 作業履歴
  WorkHistory: {
    text: 'label.workHistory',
    value: 'workHistory',
    icon: ChatOutline,
    isDefault: true,
  },
  // ファイル
  File: {
    text: 'label.file',
    value: 'file',
    icon: OutlineInsertDriveFile,
    isDefault: false,
  },
  // 依存関係
  Dependency: {
    text: 'label.dependencies',
    value: 'dependency',
    icon: AccountTreeOutline,
    isDefault: false,
  },
} as const
export type TaskDetailListTabs =
  (typeof TaskDetailListTabs)[keyof typeof TaskDetailListTabs]

// タスク詳細「作業履歴」タブ内の各タブ
// 注意: Backendのenum.TaskCommentFilterと整合が取れていること
export const WorkHistoryButtonGroup = {
  // すべて
  All: {
    value: 'all',
    text: 'label.allTaskWork',
    displayUrlText: 'allTaskWork',
  },
  // 作業内容
  WorkContent: {
    value: 'workContents',
    text: 'label.taskWorkContent',
    displayUrlText: 'workContent',
  },
  // 更新履歴
  History: {
    value: 'histories',
    text: 'label.history',
    displayUrlText: 'history',
  },
  // 時間
  Time: {
    value: 'time',
    text: 'label.time',
    displayUrlText: 'time',
  },
} as const

export type WorkHistoryButtonGroup =
  (typeof WorkHistoryButtonGroup)[keyof typeof WorkHistoryButtonGroup]

// project scope
export const SortCommentButtonGroup = {
  Ascending: {
    value: 'asc',
    icon: North,
  },
  Descending: {
    value: 'desc',
    icon: South,
  },
} as const

export type SortCommentButtonGroup =
  (typeof SortCommentButtonGroup)[keyof typeof SortCommentButtonGroup]

export const TaskDisplayModeButtonGroup = {
  List: {
    id: 'task-display-mode-list',
    icon: ViewHeadline,
    tooltipType: ToolTipTypes.taskDisplayModeList,
  },
  Kanban: {
    id: 'task-display-mode-kanban',
    icon: ViewColumnOutlineSharp,
    tooltipType: ToolTipTypes.taskDisplayModeKanban,
  },
  Calendar: {
    id: 'task-display-mode-calendar',
    icon: BaselineToday,
    tooltipType: ToolTipTypes.taskDisplayModeCalendar,
  },
  Timeline: {
    id: 'task-display-mode-timeline',
    icon: ViewListOutLineSharp,
    tooltipType: ToolTipTypes.taskDisplayModeTimeline,
  },
  Gantt: {
    id: 'task-display-mode-gantt',
    icon: GanttChart24Regular,
    tooltipType: ToolTipTypes.taskDisplayModeGantt,
  },
  Evm: {
    id: 'task-display-mode-evm',
    icon: ShowChart,
    tooltipType: ToolTipTypes.taskDisplayModeEvm,
  },
} as const

export type TaskDisplayModeButtonGroup =
  (typeof TaskDisplayModeButtonGroup)[keyof typeof TaskDisplayModeButtonGroup]

export const ProjectListPanelDisplayMode = {
  List: {
    id: 'project-list-panel-display-mode-list',
    icon: ViewHeadline,
  },
  Card: {
    id: 'project-list-panel-display-mode-card',
    icon: GridViewOutline,
  },
} as const

export type ProjectListPanelDisplayMode =
  (typeof ProjectListPanelDisplayMode)[keyof typeof ProjectListPanelDisplayMode]

export const TaskCommentFilter = {
  Comments: 'comments',
  Histories: 'histories',
  CommentsAndHistories: 'commentsAndHistories',
} as const

export type TaskCommentFilter =
  (typeof TaskCommentFilter)[keyof typeof TaskCommentFilter]

// 右パネルのタブ
export const AppRightPanelTabs = {
  Chat: {
    text: 'label.chat',
    value: 'chat',
    icon: ChatOutline,
  },
  // comment out when implement related tab
  // Related: {
  //   text: 'label.related',
  //   value: 'related',
  //   icon: mdiLinkVariant,
  // },
} as const
export type AppRightPanelTabs =
  (typeof AppRightPanelTabs)[keyof typeof AppRightPanelTabs]

export const FileFilters = {
  MyFiles: 'myFiles',
  AllFiles: 'allFiles',
} as const

export type FileFilters = (typeof FileFilters)[keyof typeof FileFilters]
export const FileDetailListTabs = {
  Preview: {
    id: 'file-detail-tab-preview',
    text: 'label.preview',
    value: 'preview',
    icon: OutlinePhotoSizeSelectActual,
    isDefault: true,
  },
  UpdatedHistory: {
    id: 'file-detail-tab-updated-history',
    text: 'label.updatedHistory',
    value: 'updatedHistory',
    icon: BaselineQueryBuilder,
    isDefault: false,
  },
} as const
export type FileDetailListTabs =
  (typeof FileDetailListTabs)[keyof typeof FileDetailListTabs]

export const HTTPStatusText = {
  Conflict: 'Conflict',
} as const

export type HTTPStatusText =
  (typeof HTTPStatusText)[keyof typeof HTTPStatusText]

export const ButtonType = {
  Action: 'action',
  Normal: 'normal',
  More: 'more',
} as const
export type ButtonType = (typeof ButtonType)[keyof typeof ButtonType]

export const EventDetailAttendances = {
  Attendance: {
    text: 'label.attendance',
    value: 'attendance',
    colorClass: 'crew-badge-green',
  },
  Absence: {
    text: 'label.absence',
    value: 'absence',
    colorClass: 'crew-badge-red',
  },
}
export type EventDetailAttendances =
  (typeof EventDetailAttendances)[keyof typeof EventDetailAttendances]

export const ProjectMemberEntryDialogTabs = {
  ExistingUsers: {
    id: 0,
    text: 'label.existingUsers',
  },
  NewUsers: {
    id: 1,
    text: 'label.newUsers',
  },
} as const
export type ProjectMemberEntryDialogTabs =
  (typeof ProjectMemberEntryDialogTabs)[keyof typeof ProjectMemberEntryDialogTabs]

export const AccountSignupPage = {
  SignupExistingAccount: 'signupExistingAccount',
  SignupNewAccount: 'signupNewAccount',
  SignupError: 'signupError',
} as const
export type AccountSignupPage =
  (typeof AccountSignupPage)[keyof typeof AccountSignupPage]

export const ChatMessageMention = {
  Me: 'me',
  All: 'all',
  Here: 'here',
  Other: 'other',
}
export type ChatMessageMention =
  (typeof ChatMessageMention)[keyof typeof ChatMessageMention]

/**
 *  Type tenant setting user state
 */
export const TenantSettingUserStateType = {
  allStates: { value: 'allTenantMembers', text: 'label.allState' },
  Enabled: { value: 'enabledTenantMembers', text: 'label.enabled' },
  Disabled: { value: 'disabledTenantMembers', text: 'label.disabled' },
  Inviting: { value: 'invitingTenantMembers', text: 'label.inviting' },
}

export type TenantSettingUserStateType =
  (typeof TenantSettingUserStateType)[keyof typeof TenantSettingUserStateType]

export const UserFilters = {
  AllUsers: 'allUsers',
  InternalUsers: 'internalUsers',
  ExternalUsers: 'externalUsers',
} as const

export type UserFilters = (typeof UserFilters)[keyof typeof UserFilters]

//user chat setting display format
export const UserChatSettingDisplayFormat = {
  Timeline: {
    value: 'timeline',
    text: 'label.timelineDisplay',
  },
  Thread: {
    value: 'thread',
    text: 'label.threadDisplay',
  },
}
export type UserChatSettingDisplayFormat =
  (typeof UserChatSettingDisplayFormat)[keyof typeof UserChatSettingDisplayFormat]

//user chat setting display range
export const UserChatSettingDisplayRange = {
  DisplayAll: {
    value: 'displayAll',
    text: 'label.displayAll',
  },
  LayerOnly: {
    value: 'layerOnly',
    text: 'label.thisLayerOnly',
  },
}

export const AddExternalUserOptions = {
  Allow: {
    text: 'label.allow',
    value: 'allow',
  },
  Disallow: {
    text: 'label.disallow',
    value: 'disallow',
  },
} as const
export type AddExternalUserOptions =
  (typeof AddExternalUserOptions)[keyof typeof AddExternalUserOptions]

// Organization role
export const OrganizationRole = {
  System: {
    key: 'systemRole',
    name: 'label.systemRole',
  },
  Project: {
    key: 'projectRole',
    name: 'label.projectRole',
  },
} as const

export type OrganizationRole =
  (typeof OrganizationRole)[keyof typeof OrganizationRole]

export const ProjectMemberState = {
  allStates: { value: 'allStates', text: 'label.allState' },
  Joined: { value: 'joined', text: 'label.joined' },
  Inviting: { value: 'inviting', text: 'label.inviting' },
  waitingApproval: { value: 'waitingApproval', text: 'label.waitingApproval' },
}

export type ProjectMemberState =
  (typeof ProjectMemberState)[keyof typeof ProjectMemberState]

export const PlanId = {
  Starter: 'starter',
  Standard: 'standard',
}
export type PlanId = (typeof PlanId)[keyof typeof PlanId]

export const AttendeeMenuItems = {
  TurnOffAudio: {
    text: 'action.turnOffAudio',
    value: 'turnOffAudio',
  },
  TurnOffVideo: {
    text: 'action.turnOffVideo',
    value: 'turnOffVideo',
  },
  AppointAsMeetingHost: {
    text: 'action.appointAsMeetingHost',
    value: 'appointAsMeetingHost',
  },
  DismissAsMeetingHost: {
    text: 'action.dismissAsMeetingHost',
    value: 'dismissAsMeetingHost',
  },
  RemoveFromMeeting: {
    text: 'action.removeFromMeeting',
    value: 'removeFromMeeting',
  },
}
export type AttendeeMenuItems =
  (typeof AttendeeMenuItems)[keyof typeof AttendeeMenuItems]

// RightSideBarの表示種類
export const RightSideBarDisplayType = {
  Feed: 'feed',
  Attention: 'attention',
  Bookmark: 'bookmark',
  ProjectDetail: 'projectDetail',
  EventDetail: 'eventDetail',
  TaskDetail: 'taskDetail',
  FileDetail: 'fileDetail',
  DirectChannel: 'directChannel',
  CrossSearchChat: 'crossSearchChat',
  AiAssistant: 'aiAssistant',
} as const
export type RightSideBarDisplayType =
  (typeof RightSideBarDisplayType)[keyof typeof RightSideBarDisplayType]

// タスク一覧項目名（ソート用）
export const CrewTaskListItemName = {
  ReferenceNo: 'referenceNo', // タスクID
  // FIXME: タスク一覧の関連先ソートをどうするか検討
  //        https://break-tmc.atlassian.net/browse/CREW-6824
  RelatedItem: 'entityType', // 関連先
  TaskKind: 'taskKindName', // 種別
  Subject: 'subject', // 件名
  TaskPriority: 'taskPriority', // 優先度
  TaskState: 'taskStateDisplayOrder', // 状態
  TaskCategory: 'taskCategoryName', // 分類
  AssignToUser: 'assignToUserName', // 担当者
  StartDate: 'startDate', // 開始日
  DueDate: 'dueDate', // 期限
} as const
export type CrewTaskListItemName =
  (typeof CrewTaskListItemName)[keyof typeof CrewTaskListItemName]

export const UnsortedFolder = {
  value: 'unsorted',
  text: 'label.unsorted',
}

export type UnsortedFolder =
  (typeof UnsortedFolder)[keyof typeof UnsortedFolder]

export const DisplayAnonymousFile = {
  Display: {
    text: 'label.show',
    value: 'show',
  },
  DoNotDisplay: {
    text: 'label.doNotDisplay',
    value: 'doNotDisplay',
  },
} as const
export type DisplayAnonymousFile =
  (typeof DisplayAnonymousFile)[keyof typeof DisplayAnonymousFile]

// Task search options
export const TaskSearchOptions = {
  Keyword: {
    id: 'keyword',
    name: 'keyword',
    label: 'label.keyword',
    defaultValue: undefined,
    defaultShown: true,
  },
  TaskKindId: {
    id: 'taskKindId',
    name: 'taskKindId',
    label: 'label.taskKind',
    defaultValue: [],
    defaultShown: false,
  },
  AssignToUser: {
    id: 'assignToUser',
    name: 'assignToUser',
    label: 'label.assignedUser',
    defaultValue: undefined,
    defaultShown: false,
  },
  TaskStateId: {
    id: 'taskStateId',
    name: 'taskStateId',
    label: 'label.state',
    defaultValue: [],
    defaultShown: false,
  },
  TaskStateType: {
    id: 'taskStateType',
    name: 'taskStateType',
    label: 'label.statusType',
    defaultValue: [],
    defaultShown: false,
  },
  TaskPriority: {
    id: 'taskPriority',
    name: 'taskPriority',
    label: 'label.priority',
    defaultValue: [],
    defaultShown: false,
  },
  TaskCategoryId: {
    id: 'taskCategoryId',
    name: 'taskCategoryId',
    label: 'label.category',
    defaultValue: [],
    defaultShown: false,
  },
  ProjectId: {
    id: 'projectId',
    name: 'projectId',
    label: 'label.project',
    defaultValue: undefined,
    defaultShown: false,
  },
  ProjectGroupId: {
    id: 'projectGroupId',
    name: 'projectGroupId',
    label: 'label.projectGroup',
    defaultValue: [],
    defaultShown: false,
  },
  StartDate: {
    id: 'startDate',
    name: 'startDate',
    label: 'label.startDate',
    defaultValue: 'thatDay',
    defaultShown: false,
  },
  DueDate: {
    id: 'dueDate',
    name: 'dueDate',
    label: 'label.dueDate',
    defaultValue: 'thatDay',
    defaultShown: false,
  },
  CreatedById: {
    id: 'createdById',
    name: 'createdById',
    label: 'label.createdBy',
    defaultValue: undefined,
    defaultShown: false,
  },
  UpdatedById: {
    id: 'updatedById',
    name: 'updatedById',
    label: 'label.updatedBy',
    defaultValue: undefined,
    defaultShown: false,
  },
  CreatedAt: {
    id: 'createdAt',
    name: 'createdAt',
    label: 'label.registrationDate',
    defaultValue: 'thatDay',
    defaultShown: false,
  },
  UpdatedAt: {
    id: 'updatedAt',
    name: 'updatedAt',
    label: 'label.rolloverDate',
    defaultValue: 'thatDay',
    defaultShown: false,
  },
} as const
export type TaskSearchOptions =
  (typeof TaskSearchOptions)[keyof typeof TaskSearchOptions]

// Project search options
export const ProjectSearchOptions = {
  Keyword: {
    id: 'keyword',
    name: 'keyword',
    label: 'label.keyword',
    defaultValue: undefined,
    defaultShown: true,
  },
  JoiningProjectStatus: {
    id: 'joiningProjectStatus',
    name: 'joiningProjectStatus',
    label: 'label.joiningProjectStatus.joiningStatus',
    defaultValue: [],
    defaultShown: false,
  },
  ArchivedStatus: {
    id: 'archivedStatus',
    name: 'archivedStatus',
    label: 'label.archivedProjectStatus.archivedStatus',
    defaultValue: [],
    defaultShown: false,
  },
  ProjectGroupId: {
    id: 'projectGroupId',
    name: 'projectGroupId',
    label: 'label.projectGroup',
    defaultValue: [],
    defaultShown: false,
  },
  OwnerUser: {
    id: 'ownerUser',
    name: 'ownerUser',
    label: 'label.owner',
    defaultValue: undefined,
    defaultShown: false,
  },
  CreatedAt: {
    id: 'createdAt',
    name: 'createdAt',
    label: 'label.registrationDate',
    defaultValue: 'thatDay',
    defaultShown: false,
  },
  UpdatedAt: {
    id: 'updatedAt',
    name: 'updatedAt',
    label: 'label.rolloverDate',
    defaultValue: 'thatDay',
    defaultShown: false,
  },
} as const
export type ProjectSearchOptions =
  (typeof ProjectSearchOptions)[keyof typeof ProjectSearchOptions]

// Archived status
export const ArchivedStatus = {
  Archived: {
    text: 'label.archivedProjectStatus.archived',
    value: 'archived',
  },
  Unarchive: {
    text: 'label.archivedProjectStatus.unarchive',
    value: 'unarchive',
  },
}
export type ArchivedStatus =
  (typeof ArchivedStatus)[keyof typeof ArchivedStatus]

// Joining project status
export const JoiningProjectStatus = {
  Joined: {
    text: 'label.joiningProjectStatus.joined',
    value: 'joined',
  },
  NotJoin: {
    text: 'label.joiningProjectStatus.notJoin',
    value: 'notJoin',
  },
}
export type JoiningProjectStatus =
  (typeof JoiningProjectStatus)[keyof typeof JoiningProjectStatus]

// Event search options
export const EventSearchOptions = {
  Keyword: {
    id: 'keyword',
    name: 'keyword',
    label: 'label.keyword',
    defaultValue: undefined,
    defaultShown: true,
  },
  AttendeeId: {
    id: 'attendeeId',
    name: 'attendeeId',
    label: 'label.attendee',
    defaultValue: undefined,
    defaultShown: false,
  },
  EventKindId: {
    id: 'eventKindId',
    name: 'eventKindId',
    label: 'label.meetingKind',
    defaultValue: [],
    defaultShown: false,
  },
  // TODO: Web: イベント分類の非表示対応
  // https://break-tmc.atlassian.net/browse/CREW-15049
  // EventCategoryId: {
  //   id: 'eventCategoryId',
  //   name: 'eventCategoryId',
  //   label: 'label.eventCategory',
  //   defaultValue: [],
  //   defaultShown: false,
  // },
  StartDate: {
    id: 'startDate',
    name: 'startDate',
    label: 'label.startDate',
    defaultValue: 'thatDay',
    defaultShown: false,
  },
  EndDate: {
    id: 'endDate',
    name: 'endDate',
    label: 'label.endDate',
    defaultValue: 'thatDay',
    defaultShown: false,
  },
  CreatedById: {
    id: 'createdById',
    name: 'createdById',
    label: 'label.createdBy',
    defaultValue: undefined,
    defaultShown: false,
  },
  UpdatedById: {
    id: 'updatedById',
    name: 'updatedById',
    label: 'label.updatedBy',
    defaultValue: undefined,
    defaultShown: false,
  },
  CreatedAt: {
    id: 'createdAt',
    name: 'createdAt',
    label: 'label.registrationDate',
    defaultValue: 'thatDay',
    defaultShown: false,
  },
  UpdatedAt: {
    id: 'updatedAt',
    name: 'updatedAt',
    label: 'label.rolloverDate',
    defaultValue: 'thatDay',
    defaultShown: false,
  },
} as const
export type EventSearchOptions =
  (typeof EventSearchOptions)[keyof typeof EventSearchOptions]

// File search options
export const FileSearchOptions = {
  Keyword: {
    id: 'keyword',
    name: 'keyword',
    label: 'label.keyword',
    defaultValue: undefined,
    defaultShown: true,
  },
  AnonymousFile: {
    id: 'anonymousFile',
    name: 'anonymousFile',
    label: 'label.anonymousFile',
    defaultValue: DisplayAnonymousFile.DoNotDisplay.value,
    defaultShown: true,
  },
  Tag: {
    id: 'tag',
    name: 'tag',
    label: 'label.tag',
    defaultValue: [],
    defaultShown: false,
  },
  ProjectId: {
    id: 'projectId',
    name: 'projectId',
    label: 'label.project',
    defaultValue: undefined,
    defaultShown: false,
  },
  ProjectGroupId: {
    id: 'projectGroupId',
    name: 'projectGroupId',
    label: 'label.projectGroup',
    defaultValue: undefined,
    defaultShown: false,
  },
  CreatedById: {
    id: 'createdById',
    name: 'createdById',
    label: 'label.createdBy',
    defaultValue: undefined,
    defaultShown: false,
  },
  UpdatedById: {
    id: 'updatedById',
    name: 'updatedById',
    label: 'label.updatedBy',
    defaultValue: undefined,
    defaultShown: false,
  },
  CreatedAt: {
    id: 'createdAt',
    name: 'createdAt',
    label: 'label.registrationDate',
    defaultValue: 'thatDay',
    defaultShown: false,
  },
  UpdatedAt: {
    id: 'updatedAt',
    name: 'updatedAt',
    label: 'label.rolloverDate',
    defaultValue: 'thatDay',
    defaultShown: false,
  },
} as const
export type FileSearchOptions =
  (typeof FileSearchOptions)[keyof typeof FileSearchOptions]

// Detail task search options
export const DetailTaskSearchOptions = {
  Keyword: {
    id: 'keyword',
    name: 'keyword',
    label: 'label.keyword',
    defaultValue: undefined,
    defaultShown: true,
  },
  TaskKindId: {
    id: 'taskKindId',
    name: 'taskKindId',
    label: 'label.taskKind',
    defaultValue: [],
    defaultShown: false,
  },
  AssignToUser: {
    id: 'assignToUser',
    name: 'assignToUser',
    label: 'label.assignedUser',
    defaultValue: undefined,
    defaultShown: false,
  },
  TaskStateId: {
    id: 'taskStateId',
    name: 'taskStateId',
    label: 'label.state',
    defaultValue: [],
    defaultShown: false,
  },
  TaskStateType: {
    id: 'taskStateType',
    name: 'taskStateType',
    label: 'label.statusType',
    defaultValue: [],
    defaultShown: false,
  },
  TaskPriority: {
    id: 'taskPriority',
    name: 'taskPriority',
    label: 'label.priority',
    defaultValue: [],
    defaultShown: false,
  },
  DueDate: {
    id: 'dueDate',
    name: 'dueDate',
    label: 'label.dueDate',
    defaultValue: 'thatDay',
    defaultShown: false,
  },
  TaskCategoryId: {
    id: 'taskCategoryId',
    name: 'taskCategoryId',
    label: 'label.category',
    defaultValue: [],
    defaultShown: false,
  },
  StartDate: {
    id: 'startDate',
    name: 'startDate',
    label: 'label.startDate',
    defaultValue: 'thatDay',
    defaultShown: false,
  },
  CreatedById: {
    id: 'createdById',
    name: 'createdById',
    label: 'label.createdBy',
    defaultValue: undefined,
    defaultShown: false,
  },
  UpdatedById: {
    id: 'updatedById',
    name: 'updatedById',
    label: 'label.updatedBy',
    defaultValue: undefined,
    defaultShown: false,
  },
  CreatedAt: {
    id: 'createdAt',
    name: 'createdAt',
    label: 'label.registrationDate',
    defaultValue: 'thatDay',
    defaultShown: false,
  },
  UpdatedAt: {
    id: 'updatedAt',
    name: 'updatedAt',
    label: 'label.rolloverDate',
    defaultValue: 'thatDay',
    defaultShown: false,
  },
} as const
export type DetailTaskSearchOptions =
  (typeof DetailTaskSearchOptions)[keyof typeof DetailTaskSearchOptions]

// Detail file search options
export const DetailFileSearchOptions = {
  Keyword: {
    id: 'keyword',
    name: 'keyword',
    label: 'label.keyword',
    defaultValue: undefined,
    defaultShown: true,
  },
  Tag: {
    id: 'tag',
    name: 'tag',
    label: 'label.tag',
    defaultValue: [],
    defaultShown: false,
  },
  CreatedById: {
    id: 'createdById',
    name: 'createdById',
    label: 'label.createdBy',
    defaultValue: undefined,
    defaultShown: false,
  },
  UpdatedById: {
    id: 'updatedById',
    name: 'updatedById',
    label: 'label.updatedBy',
    defaultValue: undefined,
    defaultShown: false,
  },
  CreatedAt: {
    id: 'createdAt',
    name: 'createdAt',
    label: 'label.registrationDate',
    defaultValue: 'thatDay',
    defaultShown: false,
  },
  UpdatedAt: {
    id: 'updatedAt',
    name: 'updatedAt',
    label: 'label.rolloverDate',
    defaultValue: 'thatDay',
    defaultShown: false,
  },
  AnonymousFile: {
    id: 'anonymousFile',
    name: 'anonymousFile',
    label: 'label.anonymousFile',
    defaultValue: DisplayAnonymousFile.DoNotDisplay.value,
    defaultShown: true,
  },
  Folder: {
    id: 'folder',
    name: 'folder',
    label: 'label.folder',
    defaultValue: undefined,
    defaultShown: false,
  },
} as const
export type DetailFileSearchOptions =
  (typeof DetailFileSearchOptions)[keyof typeof DetailFileSearchOptions]

export const SearchTabs = {
  Chat: {
    text: 'label.chat',
    value: 'chat',
    icon: ChatOutline,
    isDefault: true,
  },
  Event: {
    text: 'label.meeting',
    value: 'event',
    icon: BaseOutlineVideocam,
    isDefault: false,
  },
  Task: {
    text: 'label.task',
    value: 'task',
    icon: EventAvailable,
    isDefault: false,
  },
  File: {
    text: 'label.file',
    value: 'file',
    icon: OutlineInsertDriveFile,
    isDefault: false,
  },
  Project: {
    text: 'label.project',
    value: 'project',
    icon: Groups,
    isDefault: false,
  },
} as const
export type SearchTabs = (typeof SearchTabs)[keyof typeof SearchTabs]

export const AttendeeViewStyles = {
  displayOnTheBottom: {
    text: 'label.displayOnTheBottom',
    value: 'displayOnTheBottom',
  },
  displayOnTheRight: {
    text: 'label.displayOnTheRight',
    value: 'displayOnTheRight',
  },
  doNotDisplay: {
    text: 'label.doNotDisplay',
    value: 'doNotDisplay',
  },
}
export type AttendeeViewStyles =
  (typeof AttendeeViewStyles)[keyof typeof AttendeeViewStyles]

export const PaymentMethod = {
  creditCard: {
    value: 'creditCard',
    text: 'label.creditCard',
  },
  bankTransfer: {
    value: 'bankTransfer',
    text: 'label.bankTransfer',
  },
}
export type PaymentMethod = (typeof PaymentMethod)[keyof typeof PaymentMethod]

export const FolderMenuContextItems = {
  CreateSubFolder: {
    text: 'action.createSubFolder',
    value: 'createSubFolder',
  },
  EditFolder: {
    text: 'action.editFolder',
    value: 'editFolder',
  },
  DeleteFolder: {
    text: 'action.deleteFolder',
    value: 'deleteFolder',
  },
}

export type FolderMenuContextItems =
  (typeof FolderMenuContextItems)[keyof typeof FolderMenuContextItems]

export const isFolderContextMenuItem = (
  item: any
): item is FolderMenuContextItems => {
  return (
    Boolean(item) &&
    (item as FolderMenuContextItems).value !== undefined &&
    (item as FolderMenuContextItems).text !== undefined
  )
}

export const FileListDisplayMode = {
  List: {
    id: 'file-list-display-mode-list',
    icon: ViewHeadline,
    tooltipType: ToolTipTypes.projectDetailFileDisplayModeList,
  },
  Grid: {
    id: 'file-list-display-mode-grid',
    icon: GridViewOutline,
    tooltipType: ToolTipTypes.projectDetailFileDisplayModeGrid,
  },
} as const

export type FileListDisplayMode =
  (typeof FileListDisplayMode)[keyof typeof FileListDisplayMode]

export const ProjectDetailEventListDisplayMode = {
  Calendar: {
    id: 'project-detail-event-list-display-mode-calendar',
    icon: BaselineToday,
    tooltipType: ToolTipTypes.eventDisplayModeCalendar,
  },
  List: {
    id: 'project-detail-event-list-display-mode-list',
    icon: ViewHeadline,
    tooltipType: ToolTipTypes.eventDisplayModeList,
  },
} as const

export type ProjectDetailEventListDisplayMode =
  (typeof ProjectDetailEventListDisplayMode)[keyof typeof ProjectDetailEventListDisplayMode]

// 左上の選択ドロップダウンは「月間」と「週間」
export const TimePeriod = {
  Weekly: {
    value: 'weekly',
    text: 'label.weekly',
  },
  Monthly: {
    value: 'monthly',
    text: 'label.monthly',
  },
} as const

export type TimePeriod = (typeof TimePeriod)[keyof typeof TimePeriod]

export const TaskContextMenuItems = {
  Detail: {
    action: 'detail',
    label: 'action.detail',
  },
  Edit: {
    action: 'edit',
    label: 'action.edit',
  },
} as const satisfies { [key: string]: ContextMenuItem }

export const ProjectDetailEventTimePeriod = {
  Weekly: {
    value: 'weekly',
    text: 'label.weekly',
  },
  Monthly: {
    value: 'monthly',
    text: 'label.monthly',
  },
  GroupMonthly: {
    value: 'groupMonthly',
    text: 'label.groupMonthly',
  },
} as const

// 議事録の表示形式
export const MinutesDisplayMode = {
  Minutes: {
    value: 'minutes',
    text: 'label.meetingMinutes',
  },
  Transcription: {
    value: 'transcription',
    text: 'label.transcription',
  },
} as const

// actionMenuTypeの型を定義
export const AnnouncementContextMenuType = {
  // お知らせ一覧の上部に表示される三点リーダーの場合
  ForAll: 'forAll',
  // お知らせ一覧の各メッセージに表示される三点リーダーの場合
  ForSingle: 'forSingle',
} as const

export type AnnouncementContextMenuType =
  (typeof AnnouncementContextMenuType)[keyof typeof AnnouncementContextMenuType]

/**
 * Fullstarで使用するタグのうち、契約プラン系のもの
 */
export const FullstarTagPlan = {
  Free: 'フリー',
  Standard: 'スタンダード',
  Professional: 'プロフェッショナル',
} as const
export type FullstarTagPlan =
  (typeof FullstarTagPlan)[keyof typeof FullstarTagPlan]

/**
 * Fullstarで使用するタグのうち、管理者系のもの
 */
export const FullstarTagAdmin = {
  Admin: '管理者',
  TenantAdmin: '組織管理者',
} as const
export type FullstarTagAdmin =
  (typeof FullstarTagAdmin)[keyof typeof FullstarTagAdmin]

/**
 * Fullstarで使用するタグ
 */
export const FullstarTag = {
  ...FullstarTagPlan,
  ...FullstarTagAdmin,
} as const
export type FullstarTag = (typeof FullstarTag)[keyof typeof FullstarTag]
